import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import queryString from 'query-string';
import axios from 'axios';

import Login from './Login';
import Head from 'components/common/Head';

import useSnackbar from '@twicapp/ui/hooks/useSnackbar';

import { saveAuthCookie } from 'utils/auth';
import { RootRoutes } from 'utils/routeGenerator';

import useMutationCreateLink from 'hooks/useMutationCreateLink';
import useMutationCreateLogin from 'hooks/useMutationCreateLogin';
import useMutationCreateSSO from 'hooks/useMutationCreateSSO';

const LoginPage = () => {
  const location = useLocation();
  const history = useHistory();
  const { showErrorSnackbar } = useSnackbar();
  const [status, setStatus] = useState<string>();
  const [email, setEmail] = useState<string>();
  const { type, message } = queryString.parse(location.search);

  useEffect(() => setStatus(''), []);

  // Show notification from query params
  useEffect(() => {
    if (message) {
      showErrorSnackbar({
        text: message,
      });
    }
  }, [showErrorSnackbar, message]);

  const handleError = (e: unknown) => {
    // ts requires the catch clause errors to be of `any` or `unknown` (default) type,
    // so we add a type check below for accessing the error message
    console.log('error', e);
    if (axios.isAxiosError(e) && e?.response?.data?.message) {
      showErrorSnackbar({
        text: e.response.data.message,
      });
    }
    setStatus('error');
  };

  const { mutate: createLink } = useMutationCreateLink({
    onSuccess: () => setStatus('sent'),
    onError: handleError,
  });
  const { mutate: createLogin } = useMutationCreateLogin({
    onSuccess: ({ token }) => {
      saveAuthCookie(token);
      history.push(RootRoutes.home());
    },
    onError: handleError,
  });
  const { mutate: createSSO } = useMutationCreateSSO({
    onSuccess: ({ log_in_method, redirect }) => {
      setStatus('');
      if (log_in_method === 'sso') {
        window.location.href = redirect;
      } else if (log_in_method === 'password') {
        history.push(RootRoutes.login({ type: 'password' }));
      }
    },
    onError: handleError,
  });

  const onNext = async ({
    email,
    password,
    recaptcha,
  }: {
    email?: string;
    password: string;
    recaptcha?: string | null;
  }) => {
    setStatus('loading');
    setEmail(email);

    switch (type) {
      case 'magic':
        createLink({ type, email });
        break;

      case 'password':
        createLogin({
          email,
          password,
          recaptcha,
        });
        break;

      default:
        createSSO({ email });
    }
  };

  return (
    <>
      <Head title={'Login'} />
      <Login status={status} email={email} type={type} onNext={onNext} />
    </>
  );
};

export default LoginPage;
